import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button, Stack } from '@mui/material';
import React, { useRef } from 'react';

import { TemplatesTable } from 'components/TemplatesTable';
import {
  TEMPLATE_TYPE_ITEMS,
  TEMPLATE_INPUT_TYPE_ITEMS,
} from 'constants/template';

export function Templates() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout
      title="Шаблоны"
      actionContent={
        <Stack direction="row" spacing={2} sx={{ ml: 5 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              // @ts-ignore
              tableRef.current?.openNewTemplateForm('image');
            }}
          >
            Добавить изображение
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              // @ts-ignore
              tableRef.current?.openNewTemplateForm('video');
            }}
          >
            Добавить видео
          </Button>
        </Stack>
      }
    >
      <TemplatesTable
        id="templates-table"
        ref={tableRef}
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по ID или названию',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [
              ...(parseInt(str, 10)
                ? [{ id: { _eq: parseInt(str, 10) } }]
                : []),
              { name: { _ilike: `%${str}%` } },
            ]),
          }),
        }}
        customFilter={{
          filters: [
            {
              type: 'select',
              name: 'Тип',
              field: 'type',
              items: TEMPLATE_TYPE_ITEMS,
            },
            {
              type: 'select',
              name: 'Тип ввода',
              field: 'inputType',
              items: TEMPLATE_INPUT_TYPE_ITEMS,
            },
            {
              name: 'Премиум',
              field: 'isPremium',
              type: 'boolean',
            },
          ],
        }}
      />
    </TablePageLayout>
  );
}
